import React, { useCallback } from 'react';

import { Partner } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

type Props = {
  partner: Partner;
};

const displayDisconnect = (partner: Partner): boolean => {
  switch (partner.type) {
    case 'fhir':
    case 'insulet':
      return false;

    default:
      return true;
  }
};

const StopSharingButton: React.FC<React.PropsWithChildren<Props>> = ({ partner }) => {
  const stopSharing = useCallback(() => {
    if (partner.id) {
      mediator.publish('partner:removeConsentModal', {
        partner,
      });
    }
  }, [partner]);

  let disconnectButton: JSX.Element | null = null;

  if (displayDisconnect(partner)) {
    disconnectButton = (
      <button
        id="disconnect-btn"
        className="btn font-weight-bold text-danger ml-auto mb-3 flex-shrink-0"
        onClick={stopSharing}
      >
        {i18n.t('Common.stopSharing', { context: 'cap' })}
      </button>
    );
  }

  return <>{disconnectButton}</>;
};

export default StopSharingButton;
